import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';

import { translations } from '@akademiasaas/shared';

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources: translations,
    lng: 'pl',
    fallbackLng: ['pl', 'en'],
    defaultNS: 'common',
    ns: ['common', 'auth', 'dashboard', 'settings', 'subscription', 'matura', 'mojeSprawdzenia', 'students', 'start'],
    interpolation: {
      escapeValue: false,
    },
    react: {
      transSupportBasicHtmlNodes: true,
    },
  });

export default i18n;
